angular.module("ainapp")
    .controller("VacationRequestController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", "LanguageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window, LanguageService) {

            $scope.PageName = "Vacation Request";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })

            $scope.PayrollSetting = {};
            $scope.PayDays = 0;
            MainService.GetPayrollSettings().then(function (response3) {
                $scope.PayrollSetting = response3.data;
                if ($scope.PayrollSetting.PayDays == "Actual Days") {
                    var now = new Date();
                    var days = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
                    $scope.PayDays = days;
                }
                if ($scope.PayrollSetting.PayDays == "30") {
                    $scope.PayDays = 30;
                }
                if ($scope.PayrollSetting.PayDays == "31") {
                    $scope.PayDays = 31;
                }
            })


            $scope.Init = function () {
                console.log($scope.TokenInfo);
                $scope.VacationRequest = {
                    EmployeeId: "",
                    Date: new Date(),
                    FromDate: new Date(),
                    ToDate: new Date(),
                    VacationDays: 0,
                    OpeningLeave: 0,
                    CreditedDays: 0,
                    AppliedDays: 0,
                    ApprovedDays: 0,
                    PaidDays: 0,
                    ExcessDays: 0,
                    RemainingDays: 0,

                    EncashDays: 0,
                    TotalSalary: 0,
                    TotalEncash: 0,
                    TotalExcess: 0,

                    TotalAmount: 0,
                    IsNotConsiderAsLeave: false,
                    IsEncashLeave: false,
                    IsPayExcessDaysSalary: false,
                    IsEncashRemainingDays: false,
                    EncashRemainingDays: 0,
                    OPVacationSalary: 0,

                    Remarks: "",
                    VacationRequestDetails: [],
                }

                $scope.Components = [];
                MainService.PayrollComponentsByType("Earnings").then(function (response) {
                    $scope.Components = response.data;
                    angular.forEach($scope.Components, function (e) {
                        var temp = {
                            PayrollComponentId: e.Id,
                            Remarks: "",
                            BaseAmount: 0,
                            Amount: 0,
                            Encash: 0,
                            ExcessDaysSalary: 0,
                            Total: 0,
                        }
                        $scope.VacationRequest.VacationRequestDetails.push(temp);
                    })
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                })

                MainService.GetNextVacationRequestNo().then(function (response) {
                    $scope.VacationRequest.VoucherNumber = response.data;
                })

            }
            $scope.Init();

            $scope.getEmployeeDetails = function () {

                if ($scope.VacationRequest.EmployeeId > 0) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.EmployeeById($scope.VacationRequest.EmployeeId).then(function (response) {
                            if (response.data != null) {

                                $scope.Employee = response.data;

                                $scope.VacationRequest.VacationDays = $scope.Employee.VacationDays;
                                $scope.VacationRequest.OpeningLeave = $scope.Employee.RemainingVacationDays;

                                angular.forEach($scope.VacationRequest.VacationRequestDetails, function (e) {

                                    angular.forEach($scope.Employee.EmployeePayrolls, function (a) {
                                        if (a.PayrollComponentId == e.PayrollComponentId) {
                                            e.BaseAmount = a.Amount;
                                        }
                                    })

                                })


                                $scope.VSettings = [];
                                MainService.VacationSettingsInVacationReq($scope.VacationRequest.EmployeeId).then(function (response) {
                                    $scope.VSettings = response.data;
                                }, function (err) {
                                    toastr.error($scope.LanguageData.NetworkError);
                                })

                                $scope.calculate();
                            }
                            $.LoadingOverlay("hide");
                        },
                        function (err) {
                            toastr.error($scope.LanguageData.NetworkError);
                            $.LoadingOverlay("hide");
                        });

                }


            }

            $scope.calculate = function () {
                if ($scope.VacationRequest.EmployeeId > 0) {


                    var time_difference = $scope.VacationRequest.ToDate.getTime() - $scope.VacationRequest.FromDate.getTime();
                    var days_difference = time_difference / (1000 * 60 * 60 * 24);

                    $scope.VacationRequest.AppliedDays = days_difference;

                    $scope.VacationRequest.CreditedDays = $scope.VacationRequest.VacationDays + $scope.VacationRequest.OpeningLeave;
                    $scope.VacationRequest.RemainingDays = 0;
                    $scope.VacationRequest.ExcessDays = 0;

                    if ($scope.VacationRequest.CreditedDays > $scope.VacationRequest.ApprovedDays) {
                        $scope.VacationRequest.RemainingDays = $scope.VacationRequest.CreditedDays - $scope.VacationRequest.ApprovedDays;
                    }

                    if ($scope.VacationRequest.CreditedDays < $scope.VacationRequest.ApprovedDays) {
                        $scope.VacationRequest.ExcessDays = $scope.VacationRequest.ApprovedDays - $scope.VacationRequest.CreditedDays;
                    }

                    $scope.VacationRequest.TotalSalary = 0;
                    $scope.VacationRequest.TotalEncash = 0;
                    $scope.VacationRequest.TotalExcess = 0;
                    $scope.VacationRequest.TotalAmount = 0;

                    angular.forEach($scope.VacationRequest.VacationRequestDetails, function (e) {

                        angular.forEach($scope.VSettings, function (set) {
                            if (set.PayrollComponentId == e.PayrollComponentId) {

                                var AmountPercentage = set.AmountPercentage;
                                var EncashPercentage = set.EncashPercentage;
                                var ExcessPercentage = set.ExcessPercentage;
                                var IgnoreAmount = set.IgnoreAmount;
                                var IgnoreEncash = set.IgnoreEncash;
                                var IgnoreExcess = set.IgnoreExcess;

                                e.Amount = 0
                                e.Encash = 0
                                e.ExcessDaysSalary = 0
                                e.Total = 0

                                var Amount = 0;
                                if (AmountPercentage > 0 && IgnoreAmount != true) {
                                    Amount = e.BaseAmount * (AmountPercentage / 100);
                                    Amount = Math.round(Amount * 100) / 100;
                                } else if (IgnoreAmount == true) {
                                    Amount = 0;
                                } else {
                                    Amount = e.BaseAmount;
                                }

                                if (Amount > 0) {
                                    perdayamt = Amount / $scope.PayDays;
                                    e.Amount = perdayamt * $scope.VacationRequest.PaidDays;
                                    e.Amount = Math.round(e.Amount * 100) / 100;
                                } else {
                                    e.Amount = 0;
                                }

                                if ($scope.VacationRequest.IsEncashRemainingDays && $scope.VacationRequest.EncashDays > 0) {
                                    var EncashAmount = 0;
                                    if (EncashPercentage > 0 && IgnoreEncash != true) {
                                        EncashAmount = e.BaseAmount * (EncashPercentage / 100);
                                        EncashAmount = Math.round(EncashAmount * 100) / 100;
                                    } else if (IgnoreEncash == true) {
                                        EncashAmount = 0;
                                    } else {
                                        EncashAmount = e.BaseAmount;
                                    }

                                    if (EncashAmount > 0) {
                                        var perdayamt2 = EncashAmount / $scope.PayDays;
                                        e.Encash = perdayamt2 * $scope.VacationRequest.EncashDays;
                                        e.Encash = Math.round(e.Encash * 100) / 100;
                                    } else {
                                        e.Encash = 0;
                                    }
                                }

                                if ($scope.VacationRequest.IsPayExcessDaysSalary && $scope.VacationRequest.ExcessDays > 0) {
                                    var ExcessAmount = 0;
                                    if (EncashPercentage > 0 && IgnoreEncash != true) {
                                        ExcessAmount = e.BaseAmount * (EncashPercentage / 100);
                                        ExcessAmount = Math.round(ExcessAmount * 100) / 100;
                                    } else if (IgnoreEncash == true) {
                                        ExcessAmount = 0;
                                    } else {
                                        ExcessAmount = e.BaseAmount;
                                    }

                                    if (ExcessAmount > 0) {
                                        var perdayamt3 = ExcessAmount / $scope.PayDays;
                                        e.ExcessDaysSalary = perdayamt3 * $scope.VacationRequest.ExcessDays;
                                        e.ExcessDaysSalary = Math.round(e.ExcessDaysSalary * 100) / 100;
                                    } else {
                                        e.ExcessDaysSalary = 0;
                                    }
                                }

                                e.Total = e.Amount + e.Encash + e.ExcessDaysSalary;


                                $scope.VacationRequest.TotalEncash = $scope.VacationRequest.TotalEncash + e.Encash;
                                $scope.VacationRequest.TotalEncash = Math.round($scope.VacationRequest.TotalEncash * 100) / 100;

                                $scope.VacationRequest.TotalExcess = $scope.VacationRequest.TotalExcess + e.ExcessDaysSalary;
                                $scope.VacationRequest.TotalExcess = Math.round($scope.VacationRequest.TotalExcess * 100) / 100;

                                $scope.VacationRequest.TotalAmount = $scope.VacationRequest.TotalAmount + e.Amount;
                                $scope.VacationRequest.TotalAmount = Math.round($scope.VacationRequest.TotalAmount * 100) / 100;

                                $scope.VacationRequest.TotalSalary = $scope.VacationRequest.TotalSalary + e.Total;
                                $scope.VacationRequest.TotalSalary = Math.round($scope.VacationRequest.TotalSalary * 100) / 100;


                            }
                        })

                    })

                }
            }



            $scope.SelectedDataForDelete = {};
            $scope.Delete = function (data) {
                if (!$scope.TokenInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {

                    if (data.Status == 'New') {
                        $scope.SelectedDataForDelete = data;
                        $("#deleteModal").modal("show");
                    } else {
                        toastr.info($scope.LanguageData.CannotDeleteWhileInProcess);
                    }
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteVacationRequest($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }

            $scope.AddData = function () {

                if ($scope.VacationRequest.EmployeeId == "") {
                    toastr.warning("Select Employee");
                } else {

                    $scope.VacationRequest.DateString = $scope.extractDate($scope.VacationRequest.Date);
                    $scope.VacationRequest.FromDateString = $scope.extractDate($scope.VacationRequest.FromDate);
                    $scope.VacationRequest.ToDateString = $scope.extractDate($scope.VacationRequest.ToDate);

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.SaveVacationRequest($scope.VacationRequest).then(function (response) {
                        if (response.data) {
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.NetworkError);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });

                }



            }


            $scope.loadVoucher = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.GetVacationRequest(data).then(function (response) {
                    if (response.data) {
                        $scope.VacationRequest = response.data;
                        $scope.VacationRequest.Date = new Date($scope.VacationRequest.Date);
                        $scope.VacationRequest.FromDate = new Date($scope.VacationRequest.FromDate);
                        $scope.VacationRequest.ToDate = new Date($scope.VacationRequest.ToDate);
                    } else {
                        toastr.error($scope.LanguageData.NetworkError);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });

            }


            $scope.GetBackVoucher = function (type) {
                var temp = 0;
                if ($scope.VacationRequest.Id > 0) {
                    temp = $scope.VacationRequest.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackVacationRequest(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }




                }]);
